// OOLEY Free-Shipping Progress – stabile Prestige-Integration
(function () {
  const DEBUG = false; // auf true setzen, um Logs zu sehen
  const log = (...a) => DEBUG && console.log('[ooley-progress]', ...a);

  function euros(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }
  function normalizeThreshold(val) {
    const n = parseFloat(val);
    if (!isFinite(n)) return 6900; // 69 €
    return n < 1000 ? Math.round(n * 100) : Math.round(n);
  }

  function ensureUI(el) {
    // Nachricht
    let msg = el.querySelector('.ooley-free-ship__msg');
    if (!msg) {
      const ph = el.querySelector('.text-subdued') || document.createElement('span');
      ph.classList.remove('text-subdued');
      ph.classList.add('ooley-free-ship__msg');
      if (!ph.parentNode) el.appendChild(ph);
      msg = ph;
    }
    // Progressbar
    let bar = el.querySelector('.ooley-free-ship__bar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'ooley-free-ship__bar';
      bar.setAttribute('role', 'progressbar');
      bar.setAttribute('aria-valuemin', '0');
      bar.setAttribute('aria-valuemax', '100');
      bar.innerHTML = '<span class="ooley-free-ship__bar-fill"></span>';
      el.appendChild(bar);
    }
  }

  function update(el) {
    const totalCents = parseInt(el.getAttribute('total-price'), 10) || 0;
    const thrCents = normalizeThreshold(el.getAttribute('threshold'));
    const remaining = Math.max(0, thrCents - totalCents);
    const pct = Math.max(0, Math.min(100, (totalCents / thrCents) * 100));

    const msg  = el.querySelector('.ooley-free-ship__msg');
    const fill = el.querySelector('.ooley-free-ship__bar-fill');
    const bar  = el.querySelector('.ooley-free-ship__bar');

    if (msg) {
      msg.textContent = remaining === 0
        ? '✓ Deine Bestellung ist versandkostenfrei.'
        : `Noch ${euros(remaining)} bis zum kostenlosen Versand!`;
    }
    if (fill) fill.style.width = pct + '%';
    if (bar)  bar.setAttribute('aria-valuenow', String(Math.round(pct)));

    log('update()', { totalCents, thrCents, remaining, pct });
  }

  // pro-Element Attribut-Observer (leichtgewichtig & sicher)
  function attachAttributeObserver(el) {
    if (el._ooleyMoAttached) return;
    const mo = new MutationObserver((mutList) => {
      for (const m of mutList) {
        if (m.type === 'attributes') {
          update(el);
        }
      }
    });
    mo.observe(el, { attributes: true, attributeFilter: ['total-price', 'threshold'] });
    el._ooleyMoAttached = true;
  }

  // Enhancement nur einmal pro Element
  function enhance(el) {
    if (el.dataset.ooleyEnhanced === '1') {
      update(el);
      return;
    }
    ensureUI(el);
    update(el);
    attachAttributeObserver(el);
    el.dataset.ooleyEnhanced = '1';
    log('enhanced element', el);
  }

  function initIn(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const nodes = scope.querySelectorAll('free-shipping-bar');
    if (!nodes.length) {
      log('keine free-shipping-bar im Scope gefunden');
      return;
    }
    nodes.forEach(enhance);
  }

  // After-AJAX helper: init nach DOM-Replacement, leicht verzögert
  let reinitTimer = null;
  function reinitSoon(target) {
    if (reinitTimer) return;
    reinitTimer = setTimeout(() => {
      reinitTimer = null;
      // zwei Frames warten, damit Prestige den Drawer fertig ersetzt hat
      requestAnimationFrame(() => requestAnimationFrame(() => initIn(target || document)));
    }, 50);
  }

  function wireEvents() {
    // Initial
    document.addEventListener('DOMContentLoaded', () => initIn(document));

    // Prestige feuert diese Events bei Änderungen im Cart
    ['line-item:change', 'cart:change'].forEach((name) => {
      document.addEventListener(name, (e) => {
        log(name, 'event erkannt');
        reinitSoon(document);
      });
      // zur Sicherheit auch am Root (einige Themes dispatchen an documentElement/window)
      document.documentElement.addEventListener(name, () => reinitSoon(document));
      window.addEventListener(name, () => reinitSoon(document));
    });

    // Wenn Sections (z. B. Cart-Drawer) via AJAX neu geladen werden
    document.addEventListener('shopify:section:load', (e) => {
      log('shopify:section:load', e.target);
      reinitSoon(e.target || document);
    });

    // Minimaler DOM-Observer nur für NEU hinzugefügte free-shipping-bar
    const domMo = new MutationObserver((mutList) => {
      for (const m of mutList) {
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('free-shipping-bar')) enhance(n);
            else if (n.querySelector) {
              const f = n.querySelector('free-shipping-bar');
              if (f) enhance(f);
            }
          }
        }
      }
    });
    domMo.observe(document.body, { childList: true, subtree: true });
  }

  wireEvents();
})();

